export async function initLightBox() {

    if (document.querySelector('.wp-block-gallery img, .wp-block-image img, .woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image a')) {
        const {default: fslightbox} = await import('fslightbox');

        if (typeof refreshFsLightbox === "function") {
            document.querySelectorAll('.wp-block-gallery img, .wp-block-image img').forEach((image) => {
                let src;
                if (image.hasAttribute('data-srcset')) {
                    const srcset = image.getAttribute('data-srcset').split(", ");
                    src = srcset[0].split(" ")[0];
                } else if (image.hasAttribute('srcset')) {
                    const srcset = image.getAttribute('srcset').split(", ");
                    src = srcset[0].split(" ")[0];
                } else {
                    src = image.getAttribute('src');
                }

                let a;
                const hasLink = image.parentElement.nodeName === 'A';
                if (hasLink) {
                    a = image.parentElement;
                } else {
                    a = document.createElement("a");
                }
                a.setAttribute('href', src);
                a.setAttribute('data-fslightbox', 'image');

                if ( !hasLink ) {
                    image.parentNode.insertBefore(a, image);
                    a.appendChild(image);
                }
            });

            document.querySelectorAll('.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image a').forEach((a) => {
                a.setAttribute('data-fslightbox', 'product-gallery');
            });

            refreshFsLightbox();
        }
    }
}